import { render, staticRenderFns } from "./servicePayoutwise.vue?vue&type=template&id=053c9525&scoped=true"
import script from "./servicePayoutwise.vue?vue&type=script&lang=js"
export * from "./servicePayoutwise.vue?vue&type=script&lang=js"
import style0 from "./servicePayoutwise.vue?vue&type=style&index=0&id=053c9525&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c9525",
  null
  
)

export default component.exports